import Styled from "styled-components";

export const Container = Styled.div`
  padding-bottom: 2rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding-bottom: 4.6875rem;
  }
`;

export const Content = Styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Illustration = Styled.div`
  width: 100%;
  height: 22.75rem;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    height: 45.5rem;
  }
`;

export const Message = Styled.div`
  position: absolute;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  z-index: 2;
  left: 50%;
  transform: translateX(-50%);
  width: 20.93rem;
  bottom: 29%;
  padding: 3.125rem 1.25rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    bottom: 28%;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    gap: 1.875rem;
    width: 42.5rem;
    bottom: 38%;
  }
`;

export const Pitch = Styled.div`
  max-width: 34.375rem;
  text-align: center;
  color: #ffffff;

  * {
    color: inherit !important;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    p {
      font-size: 1.5rem !important;
      line-height: 2rem !important;
      font-weight: 640;
    }
    max-width: 43.75rem;
  }
`;

export const Link = Styled.a`
  text-decoration: none;
  
  ${(props) => props.theme.breakpoints.up("large")} {
    margin-top: 5rem;
  }
`;
